
import util from './util';
import {getPageName} from './logger'


const newrelic = {

    pageInitialization() {
        try {
            const pageName = getPageName();
            window.performance.measure(`${pageName}:ui:${util.getChannelId()}:intl:bootstrap-fetch`);
            if (window?.newrelic?.setPageViewName) {
                window.newrelic.setPageViewName?.(pageName);
            }
        } catch (ex) {
            console.log("pageInitialization ERROR: " + ex);
        }
    },

    ajaxRequestStart(req) {
        try {
            let reqName = req?.url?.substring?.(req?.url?.lastIndexOf?.('/') + 1);
            reqName = reqName && reqName.split("?") && reqName.split("?")[0];
            window?.performance?.mark(`${reqName}:start`);
        } catch (ex) {
            console.log("ajaxRequestStart ERROR: " + ex);
        }
    },

    ajaxRequestEnd(reqName, pageName) {
        try {
            reqName = reqName && reqName.split("?") && reqName.split("?")[0];
            window?.performance?.mark(`${reqName}:end`);
            window?.performance?.measure(`${pageName}:api:${util.getChannelId()}:intl:${reqName}`, `${reqName}:start`, `${reqName}:end`);
        } catch (ex) {
            console.log("ajaxRequestEnd ERROR: " + ex);
        }
    },

  logApiTransitionMeasure(duration, requestName, pageName) {
        try {
            requestName = requestName && requestName.split("?") && requestName.split("?")[0];
            let sessionId = typeof (_dg_sessid) != "undefined" ? _dg_sessid : "intlddotnsa";
            let dc = typeof (dc) != "undefined" ? dc : "defaultdc";
            const allPerfMeasures = window?.performance?.getEntriesByType('measure');
            if (allPerfMeasures?.length > 0 && window?.newrelic?.interaction) {
                const interaction = window.newrelic.interaction();
                allPerfMeasures.forEach((item) => {
                    if (item?.name?.includes?.('intl')) {
                        const nameList = item?.name?.split(':') || [];
                        interaction.setName(nameList?.[0]);
                        interaction.setAttribute(`${nameList?.[1]}-${nameList?.[4]?.toLowerCase?.()}`, item?.duration);
                    }
                });
                interaction.setAttribute('api', window?.apiValue);
                interaction.setAttribute('channelId', util.getChannelId());
                // interaction.setName(`${pageName}-transition`);
                interaction.setAttribute(`api:${requestName?.toLowerCase?.()}`, duration);
                interaction.setAttribute('flowname', 'intl');
                interaction.setAttribute('loginstatus', 'true');
                interaction.setAttribute('sessionid', sessionId);
                interaction.setAttribute('region', dc);
                interaction.setAttribute('reportedby', 'intl-ui');
                interaction.save();
            }
        } catch (ex) {
            console.log("ajaxRequestEnd ERROR: " + ex);
        }
    },

    performanceMeasure(delayTimer, pageName) {
        try {

            if (delayTimer > 0) {
                setTimeout(() => {
                    if (window?.performance?.measure && !window.performancemeasured) {
                        window.performance.measure(`${pageName}:page:${util.getChannelId()}:intl:render`);
                        window.performancemeasured = true;
                    }
                    if (window?.newrelic?.finished) {
                        window.newrelic.finished?.();
                    }
                }, delayTimer);
                return null;
            }
            if (window?.performance?.measure && !window.performancemeasured) {
                window.performance.measure(`${pageName}:page:${util.getChannelId()}:intl:render`);
                window.performancemeasured = true;
            }
            if (window?.newrelic?.finished) {
                window.newrelic.finished?.();
            }

        } catch (ex) {
            console.log("performanceMeasure ERROR: " + ex);
        }
    }

}

export default newrelic;

